<div class="card-list-item" matRipple>
    <ng-content></ng-content>
</div>